import clsx from "clsx";
import { MdHub } from "react-icons/md";
import { ICON_SIZES } from "src/constants/icons";

interface ILoadingWithText {
  text?: string;
  fullSize?: boolean;
  size?: number;
  className?: string;
}

// const NewSpinner: React.FC = () => {
//   return (
//     <svg
//       width="44"
//       height="44"
//       viewBox="0 0 44 44"
//       xmlns="http://www.w3.org/2000/svg"
//       stroke="#ff0000"
//     >
//       <g fill="none" fillRule="evenodd" strokeWidth="2">
//         <circle cx="22" cy="22" r="1">
//           <animate
//             attributeName="r"
//             begin="0s"
//             dur="1.8s"
//             values="1; 20"
//             calcMode="spline"
//             keyTimes="0; 1"
//             keySplines="0.165, 0.84, 0.44, 1"
//             repeatCount="indefinite"
//           />
//           <animate
//             attributeName="stroke-opacity"
//             begin="0s"
//             dur="1.8s"
//             values="1; 0"
//             calcMode="spline"
//             keyTimes="0; 1"
//             keySplines="0.3, 0.61, 0.355, 1"
//             repeatCount="indefinite"
//           />
//         </circle>
//         <circle cx="22" cy="22" r="1">
//           <animate
//             attributeName="r"
//             begin="-0.9s"
//             dur="1.8s"
//             values="1; 20"
//             calcMode="spline"
//             keyTimes="0; 1"
//             keySplines="0.165, 0.84, 0.44, 1"
//             repeatCount="indefinite"
//           />
//           <animate
//             attributeName="stroke-opacity"
//             begin="-0.9s"
//             dur="1.8s"
//             values="1; 0"
//             calcMode="spline"
//             keyTimes="0; 1"
//             keySplines="0.3, 0.61, 0.355, 1"
//             repeatCount="indefinite"
//           />
//         </circle>
//       </g>
//     </svg>
//   );
// };

// const Spinner: React.FC = () => {
//   return (
//     <div className="grid w-full items-center overflow-x-scroll rounded-lg p-6 lg:overflow-visible">
//       <svg
//         className="text-gray-300 animate-spin"
//         viewBox="0 0 64 64"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//         width="22"
//         height="22"
//       >
//         <path
//           d="M32 3C35.8083 3 39.5794 3.75011 43.0978 5.20749C46.6163 6.66488 49.8132 8.80101 52.5061 11.4939C55.199 14.1868 57.3351 17.3837 58.7925 20.9022C60.2499 24.4206 61 28.1917 61 32C61 35.8083 60.2499 39.5794 58.7925 43.0978C57.3351 46.6163 55.199 49.8132 52.5061 52.5061C49.8132 55.199 46.6163 57.3351 43.0978 58.7925C39.5794 60.2499 35.8083 61 32 61C28.1917 61 24.4206 60.2499 20.9022 58.7925C17.3837 57.3351 14.1868 55.199 11.4939 52.5061C8.801 49.8132 6.66487 46.6163 5.20749 43.0978C3.7501 39.5794 3 35.8083 3 32C3 28.1917 3.75011 24.4206 5.2075 20.9022C6.66489 17.3837 8.80101 14.1868 11.4939 11.4939C14.1868 8.80099 17.3838 6.66487 20.9022 5.20749C24.4206 3.7501 28.1917 3 32 3L32 3Z"
//           stroke="currentColor"
//           strokeWidth="5"
//           strokeLinecap="round"
//           strokeLinejoin="round"
//         ></path>
//         <path
//           d="M32 3C36.5778 3 41.0906 4.08374 45.1692 6.16256C49.2477 8.24138 52.7762 11.2562 55.466 14.9605C58.1558 18.6647 59.9304 22.9531 60.6448 27.4748C61.3591 31.9965 60.9928 36.6232 59.5759 40.9762"
//           stroke="currentColor"
//           strokeWidth="5"
//           strokeLinecap="round"
//           strokeLinejoin="round"
//           className="text-gray-900"
//         ></path>
//       </svg>
//     </div>
//   );
// };

const SimpleSpinner: React.FC<{ size?: number; className?: string }> = ({
  size = 48,
  className = "",
}) => {
  const borderSize = Math.max(2, size * 0.1); // como mínimo 2px
  const innerSize = size - borderSize * 2;

  return (
    <div
      className={clsx([
        "flex",
        "items-center",
        "justify-center",
        "text-emerald-400 dark:text-cyan-500",
        className,
      ])}
      style={{ width: size, height: size }}
    >
      <div
        className={clsx([
          "inline-block",
          "animate-spin",
          "rounded-full",
          "border-solid",
          "border-current",
          "border-e-transparent",
          "align-[-0.125em]",
          "text-surface",
          "motion-reduce:animate-[spin_1.5s_linear_infinite]",
        ])}
        style={{
          width: innerSize,
          height: innerSize,
          borderWidth: borderSize,
        }}
      />
    </div>
  );
};

const LoadingWithText: React.FC<ILoadingWithText> = ({
  text = "",
  fullSize = false,
  size = ICON_SIZES.LG,
  className = "",
}) => {
  return (
    <div
      className={clsx([
        "flex-row",
        "items-center",
        "justify-center",
        "gap-2",
        {
          flex: fullSize,
          "inline-flex": !fullSize,
          "h-full": fullSize,
          "w-full": fullSize,
        },
      ])}
    >
      <span>
        <SimpleSpinner size={size} />
        {/* <MdHub
          size={size}
          className="animate-spin  text-blue-400 dark:text-cyan-500"
        /> */}
      </span>
      {text && <span className="text-sm font-light">{text}</span>}
    </div>
  );
};

export default LoadingWithText;
